import { useEffect, useState } from "react";
import { Input, message, Modal, Typography } from "antd";
import { useCreateCompany, useUpdateCompany } from "../utils/queryUtils";
export default function CreateCompany({ visible, setVisible, onSuccess = () => { }, isUpdate = false, defaultData = {} }) {

  const [selected, setSelected] = useState("");
  const [showError, setShowError] = useState(false);
  const [domain, setDomain] = useState("");
  // escape the forward-slash so the regex literal parses correctly
  const regex = /[@#$%&*!?\/] /
  const { mutateAsync: createCompany } = useCreateCompany();
  const { mutateAsync: updateCompany } = useUpdateCompany();

  async function submit() {
    try {
      if (!selected) {
        message.error("Please enter Australian Firm name");
        return;
      }
      if (isUpdate) {
        if (!defaultData?._id) {
          message.error("Invalid company selected for update");
          return;
        }
        const res = await updateCompany({ id: defaultData._id, name: selected });
        if (res) {
          message.success("Australian Firm updated successfully");
        } else {
          message.success("Australian Firm updated");
        }
      } else {
        if (!domain) {
          message.error("Please enter domain");
          return;
        }
        await createCompany({ name: selected, domain: domain });
        message.success("Australian Firm added successfully");
      }

      setVisible(false);
      setSelected("");
      setDomain("");
      onSuccess();
    } catch (error) {
      const apiMsg = error?.response?.data?.response || error?.response?.data?.message || null;
      const axiosMsg = error?.message || null;
      const finalMsg = apiMsg || axiosMsg || "Operation failed";
      message.error(finalMsg);
    }
  }
  const validateName = (val => {
    if (!regex.test(val)) {
      setSelected(val);
      setShowError(false);
    }
    else {
      setShowError(true);
    }

  })

  useEffect(() => {
    if (isUpdate && defaultData) {
      setSelected(defaultData.name || "");
      setDomain(defaultData.domain || "");
    } else {
      setSelected("");
      setDomain("");
    }
  }, [defaultData?._id, defaultData?.name, defaultData?.domain, isUpdate, visible]);

  return (
    <Modal
      open={visible}
      onCancel={() => setVisible(false)}
      title={<h6 className="font-semibold m-0">{isUpdate ? `Edit Australian Firm ${defaultData?.name}` : "Add new Australian Firm"}</h6>}
      okText={isUpdate ? "Update Firm" : "Add Australian Firm"}
      onOk={submit}

    >
      <label>Australian Firm Name</label>
      <Input value={selected} onChange={(ev) => validateName(ev.target.value)} required/>
      {showError ? <span style={{ color: "red", marginTop: 1, marginBottom: 1, fontSize: "12px" }}>Please do not enter special charecters like '@#$%&*!?/' in Australian Firm Name
        <br></br></span> : ''}
      <label>Domain</label>
      <Input placeholder="example.com" disabled={isUpdate} value={domain} onChange={(ev) => setDomain(ev.target.value)} required/>
      <div style={{ marginTop: "0.35rem" }}>
        {domain ? <Typography.Text
          code={true}
        >{`${process.env.REACT_APP_HOME}/invite/${domain}`}</Typography.Text> : <></>}
      </div>
    </Modal>
  );
}
